module.exports = __webpack_public_path__ + "static/media/galerija_2017 (40).880a9190.jpg";